<template>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :push-list="studentDeletionRequestListPush"
    :query-list="queryList"
  >
    <div slot="header-item">
      <v-select-apply-state
        class="table-filter-select"
        v-model="queryList.apply_state"
        @input="handleApplyStateChange"
        size="small"
        placeholder="审核状态"
      />
    </div>
    <v-column-time value="申请时间"/>
    <v-column-avatar label="申请者" avatar-key="admin_avatar" nickname-key="admin_nickname"/>
    <el-table-column
      v-if="isAdministrator"
      label="申请门店"
      width="150"
      align="center"
      prop="add_store_name"
    />
    <v-column-student label="被注销学员" link-page-id="student_id"/>
    <el-table-column
      v-if="isAdministrator"
      label="学员注册来源"
      width="150"
      align="center"
      prop="store_name"
    />
    <el-table-column label="注销原因" width="300" align="center" prop="delete_cause"/>
    <el-table-column label="审核状态" width="150" align="center">
      <template v-slot="{ row }">
        <span
          v-for="state in findApplyState(row.apply_state)"
          :key="`listApplyState${state.value}`"
          :class="`${state.tagType}-color`"
        >
          {{ state.name }}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="操作" align="center">
      <template v-slot="{ row }">
        <v-list-button
          name="查看"
          icon="view"
          :to="studentDeletionRequestDetailTo(row.id)"
        />
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`apply-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-title border-bottom">
              <span>{{ v.add_time | timeToYmdHi }}</span>
              <span>{{ v.store_name }}</span>
            </div>
            <div class="divider"></div>
            <div class="list-item-detail">
              <span>申请人员</span>
              <span>{{ v.admin_nickname }}</span>
            </div>
            <div class="list-item-detail">
              <span>注销原因</span>
              <span v-if="v.delete_cause" class="danger-color">{{ v.delete_cause }}</span>
              <span v-else class="info-color">未填写</span>
            </div>
            <div class="list-item-detail">
              <span>审核状态</span>
              <span
                v-for="state in findApplyState(v.apply_state)"
                :key="`mobileListApplyState${state.value}`"
                :class="`${state.tagType}-color`"
              >
                {{ state.name }}
              </span>
            </div>
            <div class="list-item-button">
              <v-list-button
                name="查看"
                icon="view"
                :to="studentDeletionRequestDetailTo(v.id)"
              />
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>

</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import updateTypes from '@/enums/cardUpdateTypes';
import { applyStates, findApplyState } from '@/enums/applyStates';
import { index } from '@/api/student-deletion-request';
import { getLegalQueryList } from "@/utils/formats";

export default {
  name: RouteConfig.studentDeletionRequestList.name,
  data: () => ({
    studentDeletionRequestListPush: RouteConfig.studentDeletionRequestList.push,
    studentDeletionRequestDetailTo: RouteConfig.studentDeletionRequestDetail.to,
    count: 0,
    list: [],
    stores: [],
    queryList: {
      is_asc: 0,
      apply_state: applyStates.review.value,
      page: 1,
      size: 8,
    },
    isLoading: false,
    isDetailLoading: false,
    isShowPassAllTip: false,
    isPassingAll: false,
    isRevokingIds: [],
    isPassingIds: [],
    isRejectingIds: [],
    applyInfo: {
      id: 0,
      update_state: applyStates.review.value,
      update_remark: '',
      store: {},
      administrator: {},
      student: {},
      old_student: {},
      card_name: '',
      card_type_name: '',
      card_number: '',
      is_generic: 0,
      is_number_limit: 0,
      is_private: 0,
      expire_number: 0,
      expire_days: 0,
      expire_time: 0,
      actual_payment: 0,
      card_payment_mode_name: '',
      payment_remark: '',
      old_card_name: '',
      old_card_type_name: '',
      old_card_number: '',
      old_is_generic: 0,
      old_is_number_limit: 0,
      old_is_private: 0,
      old_expire_number: 0,
      old_expire_days: 0,
      old_expire_time: 0,
      old_actual_payment: 0,
      old_card_payment_mode_name: '',
      old_payment_remark: '',
    },
    updateTypes,
    applyStates,
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  computed: {
    ...mapGetters([
      'isMobile',
      'isAdministrator',
      'userStoreId',
    ]),
  },
  methods: {
    findApplyState,
    refresh() {
      this.studentDeletionRequestListPush(this.queryList);
    },
    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },
    handleApplyStateChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      const { query } = route;

      getLegalQueryList(queryList, query);
      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
  },
  beforeMount() {
    this.load();
  },
};
</script>
